/** @format */

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Container } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { logoutFunc, signOut } from "../../../Features/AuthSlice";
import {
  emptyProfile,
  getProfile,
} from "../../../Features/Profile_management/profileSlice";
import { clearAllValue } from "../../../Features/SetsAPI/LocalSetSlice";
import { clearSession } from "../../../Features/SetsAPI/SetsSlice";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import fallBackImg from "../../../Assets/img/fallbackimg.png";
import NotificationComponent from "./Notification/NotificationComponent";

export default function DashboardHeader() {
  const [agencyName, setAgencyName] = useState("");
  const [agencyPhone, setAgencyPhone] = useState("");
  const [agencyAddress, setAgencyAddress] = useState("");
  const [agencyEmail, setAgencyEmail] = useState("");

  useEffect(() => {
    const storedLogo = localStorage.getItem("agencyLogo");
    const storedName = localStorage.getItem("agencyName");
    const storedPhone = localStorage.getItem("agencyPhone");
    const storedAddress = localStorage.getItem("agencyAddress");
    const storedEmail = localStorage.getItem("agencyEmail");

    if (storedName) setAgencyName(storedName);
    if (storedPhone) setAgencyPhone(storedPhone);
    if (storedAddress) setAgencyAddress(storedAddress);
    if (storedEmail) setAgencyEmail(storedEmail);
  }, []);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let isEmailVerified = useSelector((state) => state.auth.isEmailVerified);
  let site_Info = useSelector((state) => state.home.siteInfo);
  let token = useSelector((state) => state.auth.currentUser.token);
  let deviceToken = useSelector((state) => state.auth?.deviceToken);
  let profileInfo = useSelector((state) => state.profile.profileInfo);
  useEffect(() => {
    isEmailVerified && dispatch(getProfile(token));
  }, [dispatch, token, isEmailVerified]);
  const [show, setShow] = useState(false);
  const [urlToHeader, setUrlToHeader] = useState("");
  useEffect(() => {
    let header = window.location.pathname.split("/");
    if (header.length >= 3) {
      let newhead = header[2]
        .split("-")
        .join(" ")
        .replace("ubt", "UBT")
        .replace("buy", " ")
        .split("-")
        .join(" ");
      setUrlToHeader(newhead);
    } else {
      let newhead = header[1];
      setUrlToHeader(newhead);
    }
  }, [window.location.href]);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <header className="dashboard__header">
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center flex-wrap">
            <div>
              {/* <div className="logo">
                <a href="/#">
                  <img src={logo} alt="Learn Korean With Bibek" />
                </a>
              </div> */}
              <div className="dashboard__title">
                <h3> {urlToHeader}</h3>
              </div>
            </div>
            {isEmailVerified && (
              <>
                <div>
                  <div className="dashboard__right">
                    
                    {/* <NotificationComponent /> */}
                    {profileInfo && (
                      <div className="dashboard__user hovermenu-container">
                        <Link to="#">
                          <img
                            src={
                              profileInfo.image ?
                                profileInfo.image
                              : fallBackImg
                            }
                            alt={profileInfo.name}
                          />
                          <div className="profile-text">
                            <p>{profileInfo.name}</p>
                            <p>{profileInfo.email}</p>
                          </div>
                        </Link>
                        <ul className="dashboard-settings hovermenu">
                          {/* <li>
                            <Link to="/dashboard/profile">View Profile</Link>
                          </li>
                          <li>
                            <Link to="/dashboard/editprofile">
                              Edit Profile
                            </Link>
                          </li>

                          <li>
                            <Link to="/dashboard/favorite">Favorite</Link>
                          </li>
                          <li>
                            <Link onClick={handleShow}>About LKWB</Link>
                          </li> */}
                          <li>
                            <Link
                              onClick={(e) => {
                                e.preventDefault();
                                dispatch(signOut({ token, deviceToken }));
                                dispatch(emptyProfile());
                                navigate("/", { replace: true });
                                dispatch(logoutFunc());
                                dispatch(clearAllValue());
                                dispatch(clearSession());
                              }}
                            >
                              Logout
                            </Link>
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                </div>

                <Modal show={show} onHide={handleClose}>
                  <Modal.Header closeButton>
                    <Modal.Title>Learn Korean With Bibek</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="aboutModal">
                      <p>App Version: 1.0</p>
                      <h5>Contact Details:</h5>

                      <ul className="modalContact footer-links">
                        <li>
                          <i className=" bi-people"></i>

                          <span>{agencyName || "Bibek Tamang "}</span>
                        </li>
                        <li>
                          <i className="bi bi-geo-alt-fill"></i>
                          <span>{agencyAddress || site_Info.address}</span>
                        </li>
                        <li>
                          <i className="bi bi-telephone-fill"></i>
                          <a href={`tel:${agencyPhone || site_Info.phone}`}>
                            {agencyPhone || site_Info.phone}
                          </a>
                        </li>
                        <li>
                          <i className="bi bi-envelope-fill"></i>
                          <a href={`mailto:${agencyEmail || site_Info.email}`}>
                            {agencyEmail || site_Info.email}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </Modal.Body>
                </Modal>
              </>
            )}
          </div>
        </Container>
      </header>
    </>
  );
}
